import type React from "react";
import { useEffect, useRef } from "react";

type Organization = {
  id: number;
  name: string;
  state?: string;
  city?: string;
};

interface Props {
  org: Organization;
  onClear: () => void;
  clearSelectionLabel: string;
  labelId: string;
}

export const SelectedOrg: React.FC<Props> = ({ org, onClear, clearSelectionLabel, labelId }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const location = [org.city, org.state].filter(Boolean).join(", ");
  const inputValue = [org.name, location].filter(Boolean).join(", ");

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <div className="sid-selected-org__wrapper">
      <input
        ref={inputRef}
        className="sid-h-screen-reader-only"
        type="text"
        readOnly
        aria-labelledby={labelId}
        aria-expanded={false}
        value={inputValue}
      />
      <div className="sid-selected-org__container">
        <div className="sid-selected-org__name" aria-hidden="true">
          {org.name}
          {location && <span className="sid-selected-org__location">{location}</span>}
        </div>
        <button
          className="sid-selected-org__clear"
          aria-label={clearSelectionLabel}
          onClick={onClear}
        >
          ✕
        </button>
      </div>
    </div>
  );
};
